/**
 * Bison product cards: color swatches + text option carousels (Style / Size / Pack).
 * Uses PDP-style multi-option availability filtering.
 */
document.addEventListener('DOMContentLoaded', function () {
  function formatMoney(cents, moneyFormat) {
    if (cents == null || cents === '') return '';
    var amount = (Number(cents) / 100).toFixed(2);
    var fmt = moneyFormat || '${{amount}}';
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function parseVariants(card) {
    var el = card.querySelector('[data-card-variants]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getOptionValue(el) {
    return el.getAttribute('data-option-value') || el.getAttribute('data-color-value') || '';
  }

  function getSelectedOptions(card) {
    var selected = {};
    card.querySelectorAll(
      '[data-card-color-swatch].is-active, [data-card-option].is-active, [data-card-pack-option].is-active'
    ).forEach(function (el) {
      if (el.classList.contains('is-unavailable')) return;
      var pos =
        el.getAttribute('data-option-position') ||
        (el.hasAttribute('data-card-color-swatch')
          ? card.getAttribute('data-color-option-position')
          : '');
      var val = getOptionValue(el);
      if (pos && val !== '') selected['option' + pos] = val;
    });
    return selected;
  }

  function isOptionValueAvailable(variants, optionPos, value, selected) {
    if (!variants || !variants.length || value == null || value === '') return false;
    var posKey = 'option' + optionPos;
    return variants.some(function (v) {
      if (String(v[posKey]) !== String(value)) return false;
      for (var i = 1; i <= 3; i++) {
        if (String(i) === String(optionPos)) continue;
        var key = 'option' + i;
        if (selected[key] == null || selected[key] === '') continue;
        if (v[key] == null || v[key] === '') continue;
        if (String(v[key]) !== String(selected[key])) return false;
      }
      return true;
    });
  }

  function findVariant(variants, selected) {
    if (!variants || !variants.length) return null;
    var keys = Object.keys(selected);
    if (!keys.length) return variants[0] || null;
    return (
      variants.find(function (v) {
        return keys.every(function (key) {
          return selected[key] == null || selected[key] === '' || String(v[key]) === String(selected[key]);
        });
      }) || null
    );
  }

  function applyVariant(card, variant) {
    if (!variant) return;
    var mainImage = card.querySelector('[data-card-main-image]');
    if (mainImage && variant.image_url) {
      mainImage.src = variant.image_url;
      mainImage.removeAttribute('srcset');
    }

    var priceEl = card.querySelector('[data-card-price]');
    var compareEl = card.querySelector('[data-card-compare-price]');
    var priceWrap = card.querySelector('[data-card-price-wrap]');
    var moneyFormat = card.getAttribute('data-money-format') || '';
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price, moneyFormat);
    }
    var onSale = variant.compare_at_price > variant.price;
    if (priceWrap) priceWrap.classList.toggle('grid-price--sale', onSale);
    if (compareEl) {
      if (onSale) {
        compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
        compareEl.hidden = false;
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
        compareEl.setAttribute('hidden', '');
      }
    }

    var addBtn = card.querySelector('[data-add-to-cart-modal], [data-card-add-btn]');
    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (addBtn.tagName === 'A') {
        addBtn.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
        if (!variant.available) {
          addBtn.classList.add('is-disabled');
        } else {
          addBtn.classList.remove('is-disabled');
        }
      }
    }

    var variantInput = card.querySelector('[data-card-variant-id]');
    if (variantInput && variant.id) {
      variantInput.value = variant.id;
    }
    if (variant.id) {
      card.setAttribute('data-selected-variant-id', String(variant.id));
    }
  }

  function buildPositionMap(card) {
    var positionMap = {};
    var colorPos = card.getAttribute('data-color-option-position');
    if (colorPos) positionMap[colorPos] = '[data-card-color-swatch]';

    card.querySelectorAll('[data-card-option][data-option-position]').forEach(function (el) {
      var pos = el.getAttribute('data-option-position');
      if (pos && !positionMap[pos]) {
        positionMap[pos] = '[data-card-option][data-option-position="' + pos + '"]';
      }
    });

    // Legacy pack-only cards without data-card-option
    var packPos = card.getAttribute('data-pack-option-position');
    if (packPos && !positionMap[packPos]) {
      positionMap[packPos] = '[data-card-pack-option]';
    }

    return positionMap;
  }

  function updateOptionAvailability(card) {
    var variants = parseVariants(card);
    if (!variants || !variants.length) return;

    var positionMap = buildPositionMap(card);
    var pass;
    for (pass = 0; pass < 3; pass++) {
      var selected = getSelectedOptions(card);
      var selectionChanged = false;

      Object.keys(positionMap).forEach(function (pos) {
        var optionEls = card.querySelectorAll(positionMap[pos]);
        var firstAvailable = null;
        var activeEl = null;

        optionEls.forEach(function (el) {
          var value = getOptionValue(el);
          var available = isOptionValueAvailable(variants, pos, value, selected);
          el.classList.toggle('is-unavailable', !available);
          el.setAttribute('aria-hidden', available ? 'false' : 'true');
          el.disabled = !available;
          if (available && !firstAvailable) firstAvailable = el;
          if (el.classList.contains('is-active')) activeEl = el;
        });

        if (activeEl && activeEl.classList.contains('is-unavailable')) {
          activeEl.classList.remove('is-active');
          activeEl.setAttribute('aria-pressed', 'false');
          if (firstAvailable) {
            firstAvailable.classList.add('is-active');
            firstAvailable.setAttribute('aria-pressed', 'true');
            selectionChanged = true;
          }
        } else if (!activeEl && firstAvailable) {
          firstAvailable.classList.add('is-active');
          firstAvailable.setAttribute('aria-pressed', 'true');
          selectionChanged = true;
        }
      });

      if (!selectionChanged) break;
    }

    var variant = findVariant(variants, getSelectedOptions(card));
    applyVariant(card, variant);

    card.querySelectorAll('[data-option-carousel], [data-pack-carousel]').forEach(updatePackArrowVisibility);
  }

  function syncFromSelection(card) {
    updateOptionAvailability(card);
  }

  function updatePackArrowVisibility(carousel) {
    if (!carousel) return;
    var track = carousel.querySelector('[data-pack-scroll-track]');
    if (!track) return;
    var needsScroll = track.scrollWidth > track.clientWidth + 2;
    carousel.classList.toggle('grid-pack-carousel--no-scroll', !needsScroll);
  }

  function bindOptionGroup(card, els, hasVariantsJson, mainImage) {
    if (!els.length) return;

    var hasActive = false;
    els.forEach(function (el) {
      if (el.classList.contains('is-active')) hasActive = true;
    });
    if (!hasActive) {
      els[0].classList.add('is-active');
      els[0].setAttribute('aria-pressed', 'true');
    }

    els.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (el.classList.contains('is-unavailable') || el.disabled) return;

        var pos = el.getAttribute('data-option-position');
        var siblings = pos
          ? card.querySelectorAll(
              '[data-card-option][data-option-position="' + pos + '"], [data-card-pack-option][data-option-position="' + pos + '"]'
            )
          : els;

        siblings.forEach(function (s) {
          s.classList.remove('is-active');
          s.setAttribute('aria-pressed', 'false');
        });
        el.classList.add('is-active');
        el.setAttribute('aria-pressed', 'true');

        if (hasVariantsJson) {
          syncFromSelection(card);
        } else if (el.hasAttribute('data-card-color-swatch')) {
          var imageUrl = el.getAttribute('data-image-url');
          if (mainImage && imageUrl) {
            mainImage.src = imageUrl;
            mainImage.removeAttribute('srcset');
          }
        }
      });
    });
  }

  document.querySelectorAll('.grid-product-card, .product-card').forEach(function (card) {
    var swatches = card.querySelectorAll('[data-card-color-swatch]');
    var textOptions = card.querySelectorAll('[data-card-option], [data-card-pack-option]');
    var hasVariantsJson = !!card.querySelector('[data-card-variants]');
    var mainImage = card.querySelector('[data-card-main-image]');

    bindOptionGroup(card, swatches, hasVariantsJson, mainImage);

    // Group text options by position so Size/Style/Pack each bind independently
    var textByPos = {};
    textOptions.forEach(function (el) {
      var pos = el.getAttribute('data-option-position') || '0';
      if (!textByPos[pos]) textByPos[pos] = [];
      textByPos[pos].push(el);
    });
    Object.keys(textByPos).forEach(function (pos) {
      bindOptionGroup(card, textByPos[pos], hasVariantsJson, mainImage);
    });

    card.querySelectorAll('[data-option-carousel], [data-pack-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-pack-scroll-track]');
      if (!track) return;

      carousel.querySelectorAll('[data-pack-scroll]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var dir = parseInt(btn.getAttribute('data-pack-scroll'), 10) || 1;
          track.scrollBy({ left: dir * Math.max(80, track.clientWidth * 0.6), behavior: 'smooth' });
        });
      });

      updatePackArrowVisibility(carousel);
      track.addEventListener('scroll', function () {
        updatePackArrowVisibility(carousel);
      });
      window.addEventListener('resize', function () {
        updatePackArrowVisibility(carousel);
      });
    });

    if (hasVariantsJson) {
      updateOptionAvailability(card);
    }
  });
});
